export interface Work {
  id: number;
  title: string;
  categorySlug: string;
  summary: string;
  author: string;
  tags: string[];
  status: "连载中" | "已完结";
  chapters: number;
  heat: number;
  rating: number;
  updatedAt: string;
  cover: string;
  views: number;
}

export const works: Work[] = [
  {
    id: 1,
    title: "木叶之我的忍道我做主",
    categorySlug: "chuanyue",
    summary: "一觉醒来成了木叶下忍，没有系统也没有金手指，只能靠前世摸爬滚打练出来的狠劲，在乱世里一步步爬上忍界的顶点。",
    author: "赤丸酱",
    tags: ["穿越", "热血", "成长"],
    status: "连载中",
    chapters: 328,
    heat: 98230,
    rating: 9.4,
    updatedAt: "2026-08-19",
    views: 128000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20young%20ninja%20boy%20wearing%20orange%20and%20black%20outfit%20standing%20in%20a%20sunset%20village%20on%20a%20rooftop%20overlooking%20hidden%20leaf%20village%2C%20warm%20amber%20lighting%2C%20dynamic%20confident%20pose%2C%20vibrant%20anime%20art%2C%20clean%20simple%20background%2C%20high%20detail&width=400&height=560&seq=work-chuanyue-01&orientation=portrait",
  },
  {
    id: 2,
    title: "穿越火影：我靠打工改变命运",
    categorySlug: "chuanyue",
    summary: "别人穿越都绑系统，我却开局在木叶开了一家拉面店。本想安稳过一生，却在一碗碗拉面里，改变了整个忍界的走向。",
    author: "一碗魂",
    tags: ["穿越", "经营", "轻松"],
    status: "已完结",
    chapters: 412,
    heat: 87310,
    rating: 9.1,
    updatedAt: "2026-08-12",
    views: 105000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20cheerful%20ramen%20shop%20owner%20in%20a%20cozy%20warm%20restaurant%20kitchen%20steaming%20hot%20ramen%20bowls%2C%20warm%20orange%20and%20cream%20tones%2C%20slice%20of%20life%20vibes%2C%20vibrant%20anime%20art%2C%20clean%20composition%2C%20high%20detail&width=400&height=560&seq=work-chuanyue-02&orientation=portrait",
  },
  {
    id: 3,
    title: "忍界赘婿：开局签到木叶幼儿园",
    categorySlug: "chuanyue",
    summary: "穿越成宇智波弃子，被分到木叶幼儿园当老师。本以为是咸鱼开局，却在教小鸣人、小佐助的过程中，意外解锁了改写忍界的关键。",
    author: "月亮不睡",
    tags: ["穿越", "爽文", "养成"],
    status: "连载中",
    chapters: 267,
    heat: 76420,
    rating: 8.9,
    updatedAt: "2026-08-18",
    views: 89000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20friendly%20adult%20ninja%20teaching%20small%20children%20in%20a%20sunny%20village%20academy%20classroom%2C%20warm%20daylight%20through%20windows%2C%20gentle%20bright%20colors%2C%20cute%20vibrant%20anime%20art%2C%20simple%20warm%20background%2C%20high%20detail&width=400&height=560&seq=work-chuanyue-03&orientation=portrait",
  },
  {
    id: 4,
    title: "火影之签到千手血脉",
    categorySlug: "xitong",
    summary: "绑定签到系统，第一天觉醒木遁，第三天掌握仙人模式。当别人还在苦练体术时，我已经在思考怎么把忍界统一了。",
    author: "系统辅助君",
    tags: ["系统", "无敌", "爽文"],
    status: "连载中",
    chapters: 501,
    heat: 118650,
    rating: 9.6,
    updatedAt: "2026-08-19",
    views: 156000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20powerful%20ninja%20surrounded%20by%20glowing%20green%20wood%20style%20jutsu%20and%20floating%20holographic%20system%20interface%20panels%2C%20epic%20energy%20aura%2C%20warm%20green%20and%20amber%20tones%2C%20vibrant%20anime%20art%2C%20dramatic%20dynamic%20composition%2C%20high%20detail&width=400&height=560&seq=work-xitong-01&orientation=portrait",
  },
  {
    id: 5,
    title: "忍者直播系统：全忍界都爱看",
    categorySlug: "xitong",
    summary: "绑定直播系统后，我成为忍界第一主播。每次开播全忍界围观，大筒木看了都直呼内行，火影之位还没到手，粉丝先破亿了。",
    author: "弹幕不停",
    tags: ["系统", "轻松", "脑洞"],
    status: "已完结",
    chapters: 356,
    heat: 82450,
    rating: 8.8,
    updatedAt: "2026-08-05",
    views: 97000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20ninja%20making%20a%20live%20streaming%20gesture%20with%20floating%20chat%20bubbles%20and%20hearts%20around%20him%20on%20a%20rooftop%2C%20playful%20warm%20tones%2C%20vibrant%20pop%20anime%20art%2C%20dynamic%20fun%20composition%2C%20high%20detail&width=400&height=560&seq=work-xitong-02&orientation=portrait",
  },
  {
    id: 6,
    title: "忍者任务系统：每天一个离谱任务",
    categorySlug: "xitong",
    summary: "系统每天刷新离谱任务，从给卡卡西找小黄书到教纲手戒赌，任务千奇百怪。但每次任务完成后暴涨的实力，让我痛并快乐着。",
    author: "离谱本离",
    tags: ["系统", "搞笑", "日常"],
    status: "连载中",
    chapters: 289,
    heat: 69300,
    rating: 8.7,
    updatedAt: "2026-08-17",
    views: 78000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20ninja%20holding%20a%20glowing%20scroll%20with%20funny%20task%20popups%20floating%20around%20him%20in%20a%20village%20street%2C%20comedic%20bright%20warm%20palette%2C%20playful%20vibrant%20anime%20art%2C%20cheerful%20composition%2C%20high%20detail&width=400&height=560&seq=work-xitong-03&orientation=portrait",
  },
  {
    id: 7,
    title: "重生之我在木叶当顾问",
    categorySlug: "zhongsheng",
    summary: "上一世眼睁睁看着村子走向毁灭，这一世重生回到一切开始之前。带着未来的记忆，我要提前布局，护木叶周全。",
    author: "村口的猫",
    tags: ["重生", "权谋", "守护"],
    status: "连载中",
    chapters: 234,
    heat: 71800,
    rating: 9.0,
    updatedAt: "2026-08-16",
    views: 86000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20determined%20adult%20ninja%20overlooking%20the%20hidden%20leaf%20village%20from%20a%20cliff%20at%20dusk%2C%20contemplative%20moody%20warm%20amber%20and%20red%20tones%2C%20solemn%20vibrant%20anime%20art%2C%20cinematic%20composition%2C%20high%20detail&width=400&height=560&seq=work-zhongsheng-01&orientation=portrait",
  },
  {
    id: 8,
    title: "重活一世：这次护你周全",
    categorySlug: "zhongsheng",
    summary: "前世没能护住重要的人，这一世重来，我发誓绝不重蹈覆辙。用预知的剧情避开每一次悲剧，哪怕与整个忍界为敌。",
    author: "白茶不加糖",
    tags: ["重生", "情感", "热血"],
    status: "已完结",
    chapters: 312,
    heat: 66800,
    rating: 8.9,
    updatedAt: "2026-07-28",
    views: 74000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20two%20ninja%20silhouettes%20standing%20protectively%20together%20under%20a%20glowing%20full%20moon%2C%20emotional%20warm%20teal%20and%20amber%20tones%2C%20heartfelt%20vibrant%20anime%20art%2C%20soft%20cinematic%20lighting%2C%20high%20detail&width=400&height=560&seq=work-zhongsheng-02&orientation=portrait",
  },
  {
    id: 9,
    title: "宇智波重生：这次不灭族",
    categorySlug: "zhongsheng",
    summary: "重生为宇智波族人，面对那场即将到来的悲剧，我选择用另一种方式改写历史。灭族之夜，将永远不再发生。",
    author: "写轮眼的倔强",
    tags: ["重生", "同人", "悲情"],
    status: "连载中",
    chapters: 198,
    heat: 59100,
    rating: 9.2,
    updatedAt: "2026-08-14",
    views: 71000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20lone%20red%20eyed%20shinobi%20with%20long%20black%20hair%20standing%20in%20a%20quiet%20moonlit%20shrine%20courtyard%2C%20melancholic%20warm%20red%20and%20indigo%20tones%2C%20dramatic%20vibrant%20anime%20art%2C%20moody%20composition%2C%20high%20detail&width=400&height=560&seq=work-zhongsheng-03&orientation=portrait",
  },
  {
    id: 10,
    title: "木叶食堂的日常",
    categorySlug: "richang",
    summary: "记录木叶食堂里发生的小事，从一乐拉面的热气，到忍者们吃饭时的嬉笑打闹。温馨治愈，抚慰每一个疲惫的灵魂。",
    author: "汤勺大师",
    tags: ["日常", "治愈", "温馨"],
    status: "连载中",
    chapters: 156,
    heat: 61200,
    rating: 9.3,
    updatedAt: "2026-08-19",
    views: 82000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20cozy%20village%20canteen%20with%20ninja%20friends%20chatting%20around%20tables%20with%20steaming%20food%2C%20warm%20golden%20interior%20lighting%2C%20heartwarming%20slice%20of%20life%20anime%20art%2C%20comfortable%20bright%20palette%2C%20high%20detail&width=400&height=560&seq=work-richang-01&orientation=portrait",
  },
  {
    id: 11,
    title: "火影小学的快乐时光",
    categorySlug: "richang",
    summary: "鸣人、佐助、小樱们的校园日常，有笑有泪有成长。那些年被吐槽的吊车尾，如今也在慢慢变成独当一面的忍者。",
    author: "铅笔屑",
    tags: ["日常", "校园", "童年"],
    status: "已完结",
    chapters: 142,
    heat: 54800,
    rating: 8.6,
    updatedAt: "2026-07-20",
    views: 63000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20cheerful%20ninja%20academy%20students%20running%20through%20a%20sunny%20village%20schoolyard%20laughing%2C%20bright%20warm%20daylight%2C%20playful%20vibrant%20anime%20art%2C%20lighthearted%20warm%20palette%2C%20high%20detail&width=400&height=560&seq=work-richang-02&orientation=portrait",
  },
  {
    id: 12,
    title: "退休上忍的种田生活",
    categorySlug: "richang",
    summary: "大战结束后选择退休，在村外开了片田，种菜养花。本以为能过清净日子，却总有不请自来的老朋友上门蹭饭。",
    author: "归田居",
    tags: ["日常", "治愈", "田园"],
    status: "连载中",
    chapters: 103,
    heat: 49800,
    rating: 9.0,
    updatedAt: "2026-08-10",
    views: 58000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20relaxed%20veteran%20ninja%20in%20a%20straw%20hat%20tending%20a%20lush%20vegetable%20garden%20by%20a%20countryside%20cottage%2C%20peaceful%20golden%20afternoon%20light%2C%20serene%20warm%20vibrant%20anime%20art%2C%20calming%20composition%2C%20high%20detail&width=400&height=560&seq=work-richang-03&orientation=portrait",
  },
  {
    id: 13,
    title: "终末之战：忍界巅峰对决",
    categorySlug: "zhandou",
    summary: "改写终末之战的另一种可能，当鸣人与佐助在终结之谷走向截然不同的选择，忍界的未来也随之分岔。",
    author: "无双之刃",
    tags: ["战斗", "热血", "巅峰"],
    status: "连载中",
    chapters: 201,
    heat: 91300,
    rating: 9.5,
    updatedAt: "2026-08-18",
    views: 119000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20two%20powerful%20rival%20ninja%20clashing%20with%20massive%20energy%20blasts%20and%20swirling%20wind%20on%20a%20broken%20valley%20battlefield%20at%20night%2C%20epic%20orange%20and%20dark%20tones%2C%20explosive%20dynamic%20anime%20art%2C%20dramatic%20cinematic%20composition%2C%20high%20detail&width=400&height=560&seq=work-zhandou-01&orientation=portrait",
  },
  {
    id: 14,
    title: "七代目：我的火影之路",
    categorySlug: "zhandou",
    summary: "不再是那个吊车尾，而是肩负整个村子的七代目。面对新的威胁，他要用实力守护每一个相信他的人。",
    author: "橙色意志",
    tags: ["战斗", "成长", "守护"],
    status: "连载中",
    chapters: 276,
    heat: 87900,
    rating: 9.4,
    updatedAt: "2026-08-15",
    views: 102000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20confident%20hokage%20ninja%20in%20flowing%20orange%20cloak%20standing%20before%20his%20village%20as%20the%20sun%20rises%2C%20heroic%20powerful%20pose%2C%20warm%20orange%20dawn%20tones%2C%20epic%20vibrant%20anime%20art%2C%20awe%20inspiring%20composition%2C%20high%20detail&width=400&height=560&seq=work-zhandou-02&orientation=portrait",
  },
  {
    id: 15,
    title: "晓之逆袭：暗面的执念",
    categorySlug: "zhandou",
    summary: "以晓组织成员的视角，重新审视那场席卷忍界的战争。所谓正邪，不过是立场不同，而我要守护的，是心中那抹执念。",
    author: "红云之下",
    tags: ["战斗", "群像", "暗黑"],
    status: "连载中",
    chapters: 188,
    heat: 62300,
    rating: 8.8,
    updatedAt: "2026-08-13",
    views: 69000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20mysterious%20hooded%20akatsuki%20style%20ninja%20standing%20in%20a%20rain%20soaked%20dark%20forest%20with%20floating%20red%20clouds%2C%20moody%20dramatic%20warm%20red%20and%20dark%20tones%2C%20intense%20vibrant%20anime%20art%2C%20ominous%20cinematic%20composition%2C%20high%20detail&width=400&height=560&seq=work-zhandou-03&orientation=portrait",
  },
  {
    id: 16,
    title: "仙人模式：逆天改命",
    categorySlug: "zhandou",
    summary: "没有六道血脉，没有尾兽外挂，只有一只不够聪明的脑袋和一股不服输的狠劲。用仙人之力，正面硬撼忍界最强。",
    author: "岩隐之魂",
    tags: ["战斗", "热血", "逆袭"],
    status: "已完结",
    chapters: 245,
    heat: 67100,
    rating: 9.1,
    updatedAt: "2026-07-15",
    views: 76000,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20ninja%20channeling%20powerful%20sage%20mode%20energy%20with%20glowing%20markings%20and%20swirling%20nature%20energy%20around%20him%2C%20epic%20warm%20orange%20and%20red%20power%20aura%2C%20fierce%20vibrant%20anime%20art%2C%20dynamic%20dramatic%20composition%2C%20high%20detail&width=400&height=560&seq=work-zhandou-04&orientation=portrait",
  },
];

export const getWork = (id: number): Work | undefined =>
  works.find((w) => w.id === id);

export const getWorksByCategory = (slug: string): Work[] =>
  works.filter((w) => w.categorySlug === slug);